module.exports = __webpack_public_path__ + "media/images/flags/16/Poland-ae22dfff56f726cf82e416d906410fff.png";